/* This file is autogenerated, see readme.md for instructions */
import FilterSvgIcon from '@bloomreach/banana-theme/icons/filter.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FilterIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FilterSvgIcon />
    </Icon>
  );
});

FilterIcon.displayName = 'FilterIcon';

export default FilterIcon;
